import { useHistory } from "react-router-dom";
import * as Styles from "./Ernahrungsform.styles";
import { useState, useRef, useEffect } from "react";

// Import the Feather icons from react-icons

import flower from "assets/images/health-analyse/flower.svg";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { REZEPT } from "routes/routes";
import { useSelector } from "react-redux";
import ErnahrungsformSlider from "./ErnahrungsformSlider";

function Ernahrungsform() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentDesktopSlide, setCurrentDesktopSlide] = useState(0); // Add state for desktop slide index
  const history = useHistory();
  const { allNutritionsData } = useSelector((state) => state.coach);
  const [advantagesList, setAdvantagesList] = useState([]);

  // Extract advantages data from API response
  useEffect(() => {
    if (allNutritionsData?.advantagesData) {
      const advantages = [];
      // Loop through possible advantage keys (01_advantage, 02_advantage, etc.)
      for (let i = 1; i <= 10; i++) {
        const key = `0${i}_advantage`;
        const advantage = allNutritionsData.advantagesData[key];
        if (advantage) {
          advantages.push({
            id: i,
            title: `${i}. Vorteil ${
              allNutritionsData?.nutritionTypeData?.de_name || ""
            }`,
            description: advantage,
          });
        }
      }
      setAdvantagesList(advantages);
    }
  }, [allNutritionsData]);

  // Format text function for HTML rendering
  const formatDietText = (text) => {
    if (!text) return "";

    // Replace bullet points with HTML list items and add spacing
    return text
      .replace(/\n\n/g, "<br/><br/>") // Double line breaks
      .replace(/• /g, "<li style='margin: 14px 0'>") // Start list item with padding
      .replace(/\n/g, "</li>\n") // End list items
      .replace(
        /<li style='padding: 8px 0'>(.*?)<\/li>/g,
        '<div style="margin: 25px 0"><ul style="margin: 0; padding-left: 25px">$&</ul></div>'
      ); // More space and proper indentation
  };

  const handleBtnClick = () => {
    history.push(REZEPT);
  };

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={"Diese Ernährungsform passt für dich:"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.EvaluationSection>
          <Styles.ContentSection>
            <img src={flower} alt="Nutrition icon" />
            <Styles.DietTitle>
              {allNutritionsData?.nutritionTypeData?.de_name}
            </Styles.DietTitle>

            {allNutritionsData?.nutritionTypeData?.["01_text"] ? (
              <Styles.DietDescription
                dangerouslySetInnerHTML={{
                  __html: formatDietText(
                    allNutritionsData?.nutritionTypeData?.["01_text"]
                  ),
                }}
              />
            ) : (
              <Styles.DietDescription>
                Keine Beschreibung verfügbar
              </Styles.DietDescription>
            )}
          </Styles.ContentSection>
          <ErnahrungsformSlider advantagesList={advantagesList} />
        </Styles.EvaluationSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default Ernahrungsform;
